/*
  this file is the responsible of handle the socket connection and data
*/
import CONFIG from '../config.json'
import { incomingSocket, notification } from './typeMessages'
import { watcher } from './watcher'

const connectToSokect = (store) => {
  /* eslint-disable */
  const ws = new WebSocket(CONFIG.wsUrl)
  /* eslint-enable */

  ws.onopen = () => {
    console.info(`connect to ${CONFIG.wsUrl}`)
    ws.send(JSON.stringify({
      msgtype: 'subcription',
      nodes: ['valledetenza', 'mochileros', 'paez', 'miraflores', 'umbita']
    }))
  }

  ws.onmessage = event => {
    let payload
    try {
      payload = JSON.parse(event.data)
    } catch (e) {
      console.error('This not is a json', event.data)
      return
    }

    switch (payload.msgtype) {
      case 'indicators':

        payload.data
          .map(incomingSocket)
          .map(store.dispatch)

        // notification envents
        payload.data
          .reduce(watcher, [])
          .map(notification)
          .map(store.dispatch)
        break
      default:
    }
  }

  ws.onclose = e => {
    console.info('Socket is closed. Reconnect will be attempted in 1 second.', e.reason)
    setTimeout(() => {
      console.info('connecting...')
      connectToSokect(store)
    }, 1000)
  }

  ws.onerror = err => {
    console.error('Socket encountered error: ', err.message, 'Closing socket')
    ws.close()
  }
}

export default connectToSokect



// WEBPACK FOOTER //
// ./src/store/socket.js